const testimonials = [
  { name: "Staff Sgt. Marcus T.", city: "Ebbing ANG Base, Fort Smith", stars: 5, text: "Got emergency orders to Germany and needed a passport within 48 hours. Fast Passport Center came through. Highly recommend for military families." },
  { name: "Lisa H.", city: "Garrison Ave, Fort Smith", stars: 5, text: "Business trip to Monterrey Mexico with 2 weeks notice. No stress at all — they handled everything from start to finish." },
  { name: "The Reynolds Family", city: "Fort Smith", stars: 5, text: "4 passports for our Caribbean cruise. All done in 5 days. The kids were thrilled we didn't cancel the trip." },
];

export default function FortSmithTestimonialsSection() {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">What Fort Smith Travelers Say</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-3">{[...Array(t.stars)].map((_, j) => <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>)}</div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#EEF2F8] flex items-center justify-center"><i className="ri-user-line text-[#1A365D]"></i></div>
                <div><p className="font-semibold text-[#1A365D] text-sm">{t.name}</p><p className="text-gray-400 text-xs">{t.city}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}